<template lang="pug">
//- Move .container: .row: .cols to a .d-flex?
.container.mt-4.mt-sm-5.mb-6
    .row: .col-lg-6.offset-lg-3
        .card.shadow-sm.p-md-4.mb-3: .card-body
            h2.mb-4 Login
            form(@submit.prevent="login")
                .form-group
                    label Ihr Benutzername / Ihre E-Mail-Adresse:
                    input.form-control(v-model="username", required)
                .form-group
                    label Passwort:
                    .input-group
                        input.form-control(:type="showPassword ? 'text' : 'password'", v-model="password", required)
                        .input-group-append
                            button.btn.btn-light(type="button", @click="showPassword = !showPassword")
                                font-awesome-icon(:icon="showPassword ? 'eye' : 'eye-slash'")
                .text-right
                    button.btn.btn-primary(type="submit") Login

    .text-center.mb-3
        | Haben Sie Ihr Passwort vergessen?
        |
        br.d-block.d-sm-none
        router-link(to="/passwort-vergessen") Neues Passwort anfordern

    .text-center.small
        a(href="https://www.luftverbundrechner.de") LVR Webseite
        span.px-2 |
        a(href="https://www.luftverbundrechner.de/impressum") Impressum
        span.px-2 |
        a(href="https://www.luftverbundrechner.de/agb") AGB
        span.px-2 |
        a(href="https://www.luftverbundrechner.de/datenschutz") Datenschutz
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

library.add(faEye, faEyeSlash)

export default {
    data () {
        return {
            username: '',
            password: '',
            showPassword: false
        }
    },
    methods: {
        login () {
            const { username, password } = this
            if (username && password) {
                this.$store.dispatch('authentication/login', { username, password })
            }
        }
    }
}
</script>
